const afterSalesList = {
    path: 'aftersaleslist',
    component: resolve => require(['@/pages/admin/aftersales/aftersaleslist/index'], resolve)
}

export default afterSalesList
